import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { User } from '../../models/user/user.model';

@Injectable({
	providedIn: 'root',
})
export class UsersService {
	constructor(private http: HttpClient) {}

	getUser(): Observable<User> {
		// TODO: Context
		return this.http.get<User>('/rest/1.2/users?context=CHARTER_IVV');
	}

	logout(): Observable<void> {
		return this.http.get<void>(`/logout?callbackurl=${document.location.origin}`);
	}
}
